module.exports = __webpack_public_path__ + "4f78dc9d570ad95e3f31857f076e1a82.pdf";